var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetireIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEE4E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FEF3F2",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.9966C19.836 23.9924 19.7169 23.9829 19.6098 23.9616C18.8164 23.8038 18.1962 23.1836 18.0384 22.3902C18 22.197 18 21.9647 18 21.5C18 21.0353 18 20.803 18.0384 20.6098C18.1962 19.8164 18.8164 19.1962 19.6098 19.0384C19.803 19 20.0353 19 20.5 19H35.5C35.9647 19 36.197 19 36.3902 19.0384C37.1836 19.1962 37.8038 19.8164 37.9616 20.6098C38 20.803 38 21.0353 38 21.5C38 21.9647 38 22.197 37.9616 22.3902C37.8038 23.1836 37.1836 23.8038 36.3902 23.9616C36.2831 23.9829 36.164 23.9924 36 23.9966M26 29H30M20 24H36V32.2C36 33.8802 36 34.7202 35.673 35.362C35.3854 35.9265 34.9265 36.3854 34.362 36.673C33.7202 37 32.8802 37 31.2 37H24.8C23.1198 37 22.2798 37 21.638 36.673C21.0735 36.3854 20.6146 35.9265 20.327 35.362C20 34.7202 20 33.8802 20 32.2V24Z",
    stroke: "#D92D20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetireIcon);
export default __webpack_public_path__ + "static/media/retireIcon.e863d6674ad111a38cd8b664147c79f8.svg";
export { ForwardRef as ReactComponent };